// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module__logo___3RFCU"};